import { tokens } from "@/theme/tokens";
import { Box, Pagination, Stack, Typography } from "@mui/material";

const THEME = {
    primary: "var(--primary)",        // deep indigo (matches --primary)
    primaryHover: tokens.color.primary90,
    primarySoft: tokens.color.primary04,
    border: "#E8E4DD",         // matches --border
    textMuted: "#6B7280",      // matches --muted-foreground
    surface: "#FFFFFF",
};

const CustomPagination = ({ count, page, rowsPerPage, onPageChange }) => {
    const totalCount = Number(count) || 0;
    const currentPage = Number(page) || 0;
    const pageSize = Number(rowsPerPage) || 10;

    const startItem = totalCount === 0 ? 0 : currentPage * pageSize + 1;
    const endItem = Math.min((currentPage + 1) * pageSize, totalCount);
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

    return (
        <Box
            sx={{
                borderTop: `1px solid ${THEME.border}`,
                px: { xs: 2, sm: 3 },
                py: { xs: 1.5, sm: 2 },
                backgroundColor: THEME.surface,
                borderBottomLeftRadius: 14,
                borderBottomRightRadius: 14,
            }}
        >
            <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "stretch", sm: "center" }}
                justifyContent="space-between"
                spacing={1.5}
            >
                <Typography
                    variant="body2"
                    sx={{
                        color: THEME.textMuted,
                        fontSize: "0.8125rem",
                        fontWeight: 500,
                        textAlign: { xs: "center", sm: "left" },
                    }}
                >
                    Showing <b style={{ color: "#1F2937" }}>{startItem}-{endItem}</b> of{" "}
                    <b style={{ color: "#1F2937" }}>{totalCount}</b>
                </Typography>

                <Pagination
                    count={totalPages}
                    page={currentPage + 1}
                    onChange={(e, value) => onPageChange && onPageChange(e, value - 1)}
                    shape="rounded"
                    siblingCount={1}
                    boundaryCount={1}
                    sx={{
                        display: "flex",
                        justifyContent: { xs: "center", sm: "flex-end" },
                        "& .MuiPaginationItem-root": {
                            color: THEME.textMuted,
                            borderRadius: "8px",
                            fontSize: "0.8125rem",
                            fontWeight: 500,
                            minWidth: 32,
                            height: 32,
                            margin: "0 2px",
                            border: "none",
                            backgroundColor: "transparent",
                            transition: "all 0.18s ease",
                            "&:hover": {
                                backgroundColor: THEME.primarySoft,
                                color: THEME.primary,
                            },
                            "&.Mui-disabled": { opacity: 0.4 },
                        },
                        "& .Mui-selected": {
                            backgroundColor: `${THEME.primary} !important`,
                            color: "#FFFFFF !important",
                            fontWeight: 600,
                            boxShadow: "0 2px 6px -2px rgba(55, 48, 163, 0.45)",
                            "&:hover": {
                                backgroundColor: `${THEME.primaryHover} !important`,
                            },
                        },
                        "& .MuiPaginationItem-ellipsis": {
                            color: THEME.textMuted,
                        },
                    }}
                />
            </Stack>
        </Box>
    );
};

export default CustomPagination;